(function () {
  'use strict';
  var N = window.Noctelle || {};

  /* ---------- Countdown ---------- */
  function pad(n) { return (n < 10 ? '0' : '') + n; }
  var timers = document.querySelectorAll('[data-countdown]');
  function tick() {
    timers.forEach(function (el) {
      var end = Date.parse(el.getAttribute('data-countdown') || N.promoEnd);
      if (isNaN(end)) return;
      var diff = Math.max(0, end - Date.now());
      var d = Math.floor(diff / 864e5), h = Math.floor(diff / 36e5) % 24,
          m = Math.floor(diff / 6e4) % 60, s = Math.floor(diff / 1e3) % 60;
      var map = { d: d, h: h, m: m, s: s };
      Object.keys(map).forEach(function (k) {
        var n = el.querySelector('[data-' + k + ']');
        if (n) n.textContent = pad(map[k]);
      });
    });
  }
  if (timers.length) { tick(); setInterval(tick, 1000); }

  /* ---------- Reveal on scroll ---------- */
  var reveals = document.querySelectorAll('.reveal');
  if ('IntersectionObserver' in window) {
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) { e.target.classList.add('is-in'); io.unobserve(e.target); }
      });
    }, { rootMargin: '0px 0px -8% 0px' });
    reveals.forEach(function (el) { io.observe(el); });
  } else {
    reveals.forEach(function (el) { el.classList.add('is-in'); });
  }

  /* ---------- Drawer: lock scroll ---------- */
  var drawer = document.querySelector('[data-drawer]');
  if (drawer) {
    drawer.addEventListener('toggle', function () {
      document.documentElement.style.overflow = drawer.open ? 'hidden' : '';
    });
  }

  /* ---------- Toast ---------- */
  var toast = document.getElementById('cart-toast');
  function showToast(msg) {
    if (!toast) return;
    toast.innerHTML = msg;
    toast.classList.add('is-on');
    clearTimeout(showToast.t);
    showToast.t = setTimeout(function () { toast.classList.remove('is-on'); }, 3200);
  }
  function updateCount() {
    fetch('/cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (c) {
        document.querySelectorAll('[data-cart-count]').forEach(function (el) {
          el.textContent = c.item_count;
          el.classList.toggle('is-empty', c.item_count === 0);
          el.classList.remove('bump'); void el.offsetWidth; el.classList.add('bump');
        });
      });
  }

  /* ---------- AJAX add to cart ---------- */
  function ajaxAdd(form, btn) {
    var fd = new FormData(form);
    var original = btn ? btn.innerHTML : '';
    if (btn) { btn.disabled = true; btn.innerHTML = 'Añadiendo…'; }
    fetch('/cart/add.js', { method: 'POST', body: fd, headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json().then(function (j) { return { ok: r.ok, j: j }; }); })
      .then(function (res) {
        if (!res.ok) throw new Error(res.j.description || 'No se pudo añadir');
        updateCount();
        showToast('🎃 Añadido al carrito · <a href="/cart" style="text-decoration:underline">Ver carrito</a>');
      })
      .catch(function (err) { showToast(err.message); })
      .finally(function () { if (btn) { btn.disabled = false; btn.innerHTML = original; } });
  }
  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (form.matches('[data-ajax-cart]') || form.matches('[data-product-form]')) {
      if (!window.fetch) return;
      e.preventDefault();
      ajaxAdd(form, form.querySelector('[type="submit"]'));
    }
  });

  /* ---------- Card swatches: preview variant image ---------- */
  document.querySelectorAll('[data-swatches]').forEach(function (wrap) {
    var card = wrap.closest('.card');
    var img = card && card.querySelector('.card__img:not(.card__img--alt)');
    var link = card && card.querySelector('.card__media');
    if (!img) return;
    var original = img.getAttribute('src'), originalSet = img.getAttribute('srcset'), originalHref = link.getAttribute('href');
    function set(sw) {
      wrap.querySelectorAll('.swatch').forEach(function (x) { x.classList.toggle('is-active', x === sw); });
      if (sw && sw.dataset.img) { img.removeAttribute('srcset'); img.src = sw.dataset.img; link.href = sw.href; }
    }
    wrap.querySelectorAll('.swatch[data-img]').forEach(function (sw) {
      sw.addEventListener('mouseenter', function () { set(sw); });
      sw.addEventListener('focus', function () { set(sw); });
    });
    wrap.addEventListener('mouseleave', function () {
      if (!wrap.querySelector('.is-active')) return;
      wrap.querySelectorAll('.swatch').forEach(function (x) { x.classList.remove('is-active'); });
      img.src = original; if (originalSet) img.setAttribute('srcset', originalSet); link.href = originalHref;
    });
  });

  /* ---------- Product page ---------- */
  var product = document.querySelector('[data-product]');
  if (product) {
    var variantsEl = product.querySelector('[data-variants]');
    var variants = variantsEl ? JSON.parse(variantsEl.textContent) : [];
    var idInput = product.querySelector('[data-variant-id]');
    var addBtn = product.querySelector('[data-add]');
    var addLabel = product.querySelector('[data-add-label]');
    var priceWrap = product.querySelector('[data-price-wrap]');
    var savingEl = product.querySelector('[data-saving]');
    var money = function (cents) {
      return (cents / 100).toLocaleString('es-ES', { style: 'currency', currency: 'EUR' });
    };

    var qtyInput = product.querySelector('[data-qty-input]');
    var tiers = product.querySelector('[data-tiers]');
    var currentPrice = null;
    function syncTierFromQty() {
      if (!tiers || !qtyInput) return;
      var q = parseInt(qtyInput.value, 10) || 1;
      var val = q >= 3 ? '3' : String(q);
      var r = tiers.querySelector('input[value="' + val + '"]');
      if (r) r.checked = true;
    }
    function updateTierPrices(price) {
      if (!tiers) return;
      var t2 = parseInt(tiers.dataset.t2, 10), t3 = parseInt(tiers.dataset.t3, 10);
      var set = function (sel, v) { var el = tiers.querySelector(sel); if (el) el.textContent = money(v); };
      set('[data-tier-price="1"]', price);
      set('[data-tier-price="2"]', Math.round(price * 2 * (100 - t2) / 100));
      set('[data-tier-was="2"]', price * 2);
      set('[data-tier-price="3"]', Math.round(price * 3 * (100 - t3) / 100));
      set('[data-tier-was="3"]', price * 3);
    }
    if (tiers && qtyInput) {
      tiers.addEventListener('change', function (e) {
        if (e.target.name === 'tier') qtyInput.value = e.target.value;
      });
      qtyInput.addEventListener('input', syncTierFromQty);
    }

    product.addEventListener('change', function (e) {
      if (!e.target.matches('[data-option-index]')) return;
      var selected = [];
      product.querySelectorAll('.opt').forEach(function (fs, i) {
        var c = fs.querySelector('input:checked');
        selected[i] = c ? c.value : null;
        var label = product.querySelector('[data-opt-value="' + i + '"]');
        if (label && c) label.textContent = c.value;
      });
      var v = variants.find(function (x) {
        return x.options.every(function (o, i) { return o === selected[i]; });
      });
      if (!v) {
        addBtn.disabled = true; addLabel.textContent = 'No disponible'; return;
      }
      idInput.value = v.id;
      updateTierPrices(v.price);
      var sp = product.querySelector('[data-sticky-price]'); if (sp) sp.textContent = money(v.price);
      addBtn.disabled = !v.available;
      addLabel.textContent = v.available ? 'Añadir al carrito' : 'Agotado';
      var sale = v.compare_at_price && v.compare_at_price > v.price;
      var pct = sale ? Math.round((v.compare_at_price - v.price) * 100 / v.compare_at_price) : 0;
      priceWrap.innerHTML = '<div class="price price--lg' + (sale ? ' price--sale' : '') + '"><span class="price__now">' + money(v.price) + '</span>' +
        (sale ? '<s class="price__was">' + money(v.compare_at_price) + '</s><span class="price__save">-' + pct + '%</span>' : '') + '</div>';
      if (savingEl) {
        savingEl.hidden = !sale;
        if (sale) savingEl.textContent = 'Te ahorras ' + money(v.compare_at_price - v.price);
      }
      if (v.featured_media) {
        var slide = product.querySelector('[data-media-id="' + v.featured_media.id + '"]');
        if (slide) slide.parentNode.scrollTo({ left: slide.offsetLeft, behavior: 'smooth' });
      }
      var url = new URL(location.href); url.searchParams.set('variant', v.id);
      history.replaceState({}, '', url);
    });

    product.querySelectorAll('[data-qty]').forEach(function (b) {
      b.addEventListener('click', function () {
        var input = b.parentNode.querySelector('input');
        input.value = Math.max(1, (parseInt(input.value, 10) || 1) + parseInt(b.dataset.qty, 10));
        syncTierFromQty();
      });
    });

    /* sticky add to cart (mobile) */
    var sticky = product.querySelector('[data-sticky-atc]');
    var mainAdd = product.querySelector('[data-add]');
    if (sticky && mainAdd && 'IntersectionObserver' in window) {
      new IntersectionObserver(function (en) {
        var show = !en[0].isIntersecting && en[0].boundingClientRect.top < 0;
        sticky.classList.toggle('is-on', show);
        sticky.setAttribute('aria-hidden', show ? 'false' : 'true');
      }).observe(mainAdd);
      product.querySelector('[data-sticky-add]').addEventListener('click', function () {
        var f = product.querySelector('[data-product-form]');
        if (f.requestSubmit) f.requestSubmit(); else mainAdd.click();
      });
    }

    var gallery = product.querySelector('[data-gallery]');
    var thumbs = product.querySelectorAll('[data-thumb]');
    thumbs.forEach(function (t) {
      t.addEventListener('click', function () {
        var i = parseInt(t.dataset.thumb, 10);
        gallery.scrollTo({ left: gallery.clientWidth * i, behavior: 'smooth' });
      });
    });
    if (gallery && thumbs.length) {
      gallery.addEventListener('scroll', function () {
        var i = Math.round(gallery.scrollLeft / gallery.clientWidth);
        thumbs.forEach(function (t, j) { t.classList.toggle('is-active', i === j); });
      }, { passive: true });
    }
  }
})();
